/* eslint-disable import/order */
import issueTypeSchemeResource from '@jira/admin-pages__issue-type-schemes-directory/src/issueTypeSchemeResource.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueTypesSchemesRoute } from '@jira/router-routes__admin-pages-issue-types-routes/src/globalSettingsIssueTypesSchemesRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import IssueTypeSchemesDirectory, {
	LazyIssueTypeSchemesDirectory,
} from './ui/spa/admin-pages/issue-types/issue-type-schemes-directory/index.tsx';

export const globalSettingsIssueTypesSchemesRouteEntry: Route = createEntry(
	globalSettingsIssueTypesSchemesRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.view-issue-type-schemes',
		// eslint-disable-next-line no-restricted-syntax
		component: IssueTypeSchemesDirectory,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			issueTypeSchemeResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyIssueTypeSchemesDirectory],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
